import { useParams, useSearchParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useArticle } from '@/lib/queries';
import { ArticleForm } from '@/components/admin/article-form';
import { Button } from '@/components/ui/button';

export function AdminArticleEditPage() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const initialFind = searchParams.get('find') ?? undefined;
  const article = useArticle(id);

  const isNew = !id;
  const loading = !!id && article.isLoading;

  return (
    <div className="container-wide py-8">
      <div className="mx-auto max-w-3xl">
        <Button asChild variant="ghost" size="sm" className="-ml-2 mb-4">
          <Link to="/admin/articoli">
            <ArrowLeft className="h-4 w-4" /> Articoli
          </Link>
        </Button>

        <h1 className="font-serif text-3xl font-semibold tracking-tight">
          {isNew ? 'Nuovo articolo' : 'Modifica articolo'}
        </h1>
        <p className="mt-1 mb-8 text-sm text-(--color-muted-foreground)">
          {isNew
            ? 'Compila i campi e crea un nuovo articolo nell’archivio.'
            : 'Aggiorna i campi dell’articolo. Usa “Cerca nel testo” per evidenziare le parole.'}
        </p>

        {loading ? (
          <p className="text-sm text-(--color-muted-foreground)">Caricamento…</p>
        ) : isNew ? (
          <ArticleForm initialFind={initialFind} />
        ) : article.data ? (
          <ArticleForm
            articleId={article.data.id}
            initialFind={initialFind}
            initial={{
              anno: article.data.anno,
              mese: article.data.mese,
              data: article.data.data,
              fonte: article.data.fonte,
              titolo: article.data.titolo,
              contenuto: article.data.contenuto,
            }}
          />
        ) : (
          <p className="text-sm text-(--color-destructive)">Articolo non trovato.</p>
        )}
      </div>
    </div>
  );
}
